import { FaImage } from "react-icons/fa";

interface PartLabelProps {
  isBoxLayout: boolean;
  label: string;
  selectOnClick?: (e: React.MouseEvent<HTMLElement>) => void;
  imageOnClick: (e: React.MouseEvent<HTMLElement>) => void;
  color?: string;
  imageSrc?: string;
}

const PartLabel: React.FC<PartLabelProps> = ({
  isBoxLayout,
  label,
  selectOnClick,
  imageOnClick,
  color,
  imageSrc,
}) => {
  return (
    <span className="part-label">
      <span className="part-label-text" onClick={selectOnClick}>
        {label}
      </span>
      <span className="part-image-tooltip">
        {(imageSrc && isBoxLayout) || (imageSrc && color) ? (
          <a onClick={imageOnClick}>
            <FaImage />
          </a>
        ) : null}
      </span>
    </span>
  );
};
export default PartLabel;
